import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"


const initialState = { status: null, loading: false, data: [], error: "", message: '',total:'' }


export const singleUserTransactionAction = createAsyncThunk(
    'single-user-transaction',
    async (data, { rejectWithValue }) => {
        
        try {
            const res = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/api/single-user-transaction?user_id=${data?.user_id}&page=${data?.page}&limit=${data?.limit}`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const singleUserTranactionnSlice = createSlice({
    name: 'single-user-transaction',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(singleUserTransactionAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(singleUserTransactionAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
                state.total=action?.payload?.total
            })
            builder.addCase(singleUserTransactionAction.rejected, (state, action) => {
                state.loading = false
                state.status = action?.payload?.status
                state.data = action?.payload?.data
                state.message = action?.payload?.message
                state.error = action?.payload?.message
            })
        },

})



export const singleUserTransactionReducer = singleUserTranactionnSlice.reducer